import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { Ciudad } from "@/shared/types/ciudad";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface CiudadesQuery extends BaseQuery {
    nombre?: string;
    codigo?: string;
    departamentoId?: string;
}

export async function getAllCiudades(query?: CiudadesQuery): Promise<QueryResponse<Ciudad>> {
    await sleep(1000);
    const response = await api.get("ciudades", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllCiudadesQuery(query: CiudadesQuery = {}, queryConfig: QueryConfig<QueryResponse<Ciudad>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllCiudades(query),
        queryKey: ["ciudades", query],
    });
}

export interface GetAllCiudadesQueryProps {
    query?: CiudadesQuery;
    queryConfig?: QueryConfig<QueryResponse<Ciudad>>;
    children: (queryResult: QueryResult<QueryResponse<Ciudad>>) => ReactNode;
}

export function GetAllCiudadesQuery({
    query,
    queryConfig,
    children,
}: GetAllCiudadesQueryProps) {
    const queryResult = useGetAllCiudadesQuery(query, queryConfig);
    return children && children(queryResult);
}